






































































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import User from "@/models/user";
import IAuthenticationModel from "@/interfaces/authentication-model";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("authentication", ["token", "user"]),
  },
})
export default class UserLogin extends Vue {
  // mapState
  user!: User;
  token!: any;

  loginForm: any = {
    username: "",
    password: "",
  };

  rules: any = {
    username: [
      {
        required: true,
        message: "Please enter your username",
        trigger: ["submit"],
      },
    ],
    password: [
      {
        required: true,
        message: "Please enter your password",
        trigger: ["submit"],
      },
    ],
  };

  loading = false;

  @Ref("usernameInput")
  usernameInput!: any;

  @Ref("loginFormRef")
  loginFormRef!: any;

  mounted() {
    //
    // Set focus to the username field
    this.usernameInput.focus();
  }

  login() {
    this.loginFormRef.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;

        const model: IAuthenticationModel = {
          username: this.loginForm.username,
          password: this.loginForm.password,
        };

        this.$store.dispatch("authentication/login", model).then(
          async () => {
            this.loading = false;
            this.loginForm.username = "";
            this.loginForm.password = "";
            this.$router.push({ name: "Default" });
            //
            // Get the subscriptions
            await this.$store.dispatch("subscriptions/getSubscriptions");
            //
            // Get the settings for this user
            await this.$store.dispatch("settings/get");
          },
          () => {
            this.loading = false;
            this.$message({
              message: "Your username or password was wrong. Please try again.",
              type: "error",
            });
          }
        );
      }
    });
  }
}
